/**
 * Calibration config — Prompt.md §11.
 */

export interface CalibrationConfig {
  /** §11 — countdown 5 giây trước khi thu sample. */
  countdownMs: number;
  /** §11 — thu sample trong 5 giây. */
  collectMs: number;

  /**
   * Bỏ sample lệch quá `outlierMadFactor` lần MAD (median absolute deviation).
   *
   * Dùng median/MAD thay vì mean/σ: trong 5 giây, trẻ rất dễ ngọ nguậy 1–2 lần tạo outlier
   * biên độ lớn; mean/σ bị chính outlier đó kéo lệch (σ phình ra nên không loại được gì),
   * còn median/MAD miễn nhiễm tới 50% dữ liệu nhiễu. Đây là ~10 dòng code quyết định chất
   * lượng của MỌI threshold phía sau, vì §11 quy định toàn hệ thống so sánh tương đối với
   * baseline này.
   */
  outlierMadFactor: number;

  /** Tỉ lệ sample tối thiểu còn lại sau khi lọc, dưới mức này → NOT_ENOUGH_SAMPLES. */
  minAcceptedRatio: number;

  /** Số sample tuyệt đối tối thiểu. */
  minSamples: number;

  /**
   * MAD tối đa cho phép (độ) — trên mức này nghĩa là trẻ không ngồi yên → TOO_UNSTABLE,
   * mời calibrate lại. Baseline sai âm thầm còn tệ hơn calibrate lại.
   */
  maxBaselineSpreadDeg: number;

  /**
   * Tỉ lệ sample mà một metric phải `available` để KHÔNG bị đưa vào
   * `PostureBaseline.unavailableMetrics` (DU #3 — hông bị bàn che).
   */
  minMetricAvailabilityRatio: number;
}

export const defaultCalibrationConfig: CalibrationConfig = {
  countdownMs: 5000,
  collectMs: 5000,
  outlierMadFactor: 3,
  minAcceptedRatio: 0.6,
  minSamples: 20,
  maxBaselineSpreadDeg: 6,
  minMetricAvailabilityRatio: 0.6,
};
